import { render, staticRenderFns } from "./waitApproveDeal.vue?vue&type=template&id=04e459d8&scoped=true&"
import script from "./waitApproveDeal.vue?vue&type=script&lang=js&"
export * from "./waitApproveDeal.vue?vue&type=script&lang=js&"
import style0 from "./waitApproveDeal.vue?vue&type=style&index=0&id=04e459d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e459d8",
  null
  
)

export default component.exports